import { createFileRoute, redirect } from "@tanstack/react-router";

import { DASHBOARDS_INDEX_PATH, isDashboardsOnly } from "../dashboardsOnly";

export const Route = createFileRoute("/_app/")({
  beforeLoad: () => {
    throw redirect({
      to: isDashboardsOnly() ? DASHBOARDS_INDEX_PATH : "/operators",
      replace: true,
    });
  },
  component: () => null,
});
